module.exports = __webpack_public_path__ + "img/VideocamOffOutlined.3d466f97.svg";